import React, { useEffect, useState, useRef } from 'react';
import {View, StyleSheet, Dimensions, Animated, Text, Platform, TouchableOpacity} from 'react-native';
import LottieView from 'lottie-react-native';

const FailedEntryScreen = ({ navigation, route }) => {
    const [animationFinished, setAnimationFinished] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState('#FF3C3CFF');
    const logoOpacity = useRef(new Animated.Value(0)).current;
    const animation = useRef(null);

    const handleAnimationFinish = async () => {
        setBackgroundColor('#FF3C3CFF');
        setAnimationFinished(true)
    };
    const { ticketCode, reason = "A Jegy érvénytelen vagy már fel lett használva." } = route.params;

    return (
        <View style={[styles.container, { backgroundColor : '#FF3C3CFF' }]}>
            {animationFinished && (
                <Animated.View style={[styles.logoContainer, { opacity: 1 }]}>
                    <LottieView
                        source={require('../../assets/animations/failed_center.json')} // Path to your Lottie animation file
                        autoPlay
                        loop={true}
                        style={styles.lottieCenter}
                    />
                    <Text style={styles.logo}>Sikertelen beléptetés!</Text>
                    <Text style={[styles.logo, {fontSize: 15, textAlign: 'center'}]}>{reason}</Text>

                    <TouchableOpacity style={styles.button}
                                      onPress={() => navigation.navigate("TicketEntry")}>
                        <Text style={styles.buttonText}>Újrapróbálás</Text>
                    </TouchableOpacity>
                </Animated.View>
            )}
            {!animationFinished && <LottieView
                ref={animation}
                source={require('../../assets/animations/failed_animation.json')} // Path to your Lottie animation file
                autoPlay
                loop={false}
                speed={2}
                onAnimationFinish={handleAnimationFinish}
                resizeMode={'contain'}
                renderMode={'HARDWARE'}
                style={[styles.lottie, {width: Dimensions.get('screen').width, height: Dimensions.get('screen').height}]}
            />}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#81F174',
        width: Dimensions.get('screen').width,
        height: Dimensions.get('screen').height,
    },
    lottie: {
        width: Dimensions.get('screen').width,
        height: Dimensions.get('screen').height,
    },
    lottieCenter: {
        width: Dimensions.get('screen').width - 100,
        height: Dimensions.get('screen').width - 100,
    },
    logoContainer: {
        position: 'absolute',
        alignItems: 'center',
        zIndex: 99999999
    },
    logo: {
        fontSize: 25,
        fontWeight: 'bold',
        color: '#FFF',
    },
    text: {
        fontSize: 30,
        fontWeight: 'bold',
        color: 'black',
        marginTop: 10,
    },
    button: {
        backgroundColor: "#F1B34B",
        paddingVertical: 15,
        paddingHorizontal: 30,
        borderRadius: 5,
        marginTop: 40
    },
    buttonText: {
        fontSize: 24,
        color: "white",
        paddingHorizontal: 20,
        textAlign: 'center',
    },
});

export default FailedEntryScreen;